import userAccountApi from '@/api/Methods/User/User-Account-API-Methods';
import userEmploymentApi from '@/api/Methods/User/User-Employment-API-Methods';
import userVehicleApi from '@/api/Methods/User/User-Vehicle-API-Methods';
import client from '@/api/client.js';
import i18n from '@/plugins/i18n.js';
import store from "@/store";
export default {
    methods: {
        ...userAccountApi.methods,
        ...userEmploymentApi.methods,
        ...userVehicleApi.methods,
        
        async searchCustomerUserList(queryAndFilterObject) {
            var searchQuery = queryAndFilterObject.query ? ("?query=" + queryAndFilterObject.query) : '';
            var response = await client().get(store.state.apiRouteRoot + "User/SearchCustomerAccounts/" + searchQuery, { meta: { clientApiMethod: 'searchCustomerUserList' } })
            return response?.data;
        },
        async getUserListFromFilter(filter, cancelationToken) {
            var meta = { clientApiMethod: 'getUserListFromFilter', input: { filter: filter } }
            var response = await client().get(store.state.apiRouteRoot + "User/Filtered", { params: filter, signal: cancelationToken, meta: meta })
            return response?.data;
        },
        async getUserById(userId) {
            var meta = { clientApiMethod: 'getUserById', input: { userId: userId } }
            var response = await client().get(store.state.apiRouteRoot + "User/get/" + userId, { meta: meta })
            return response?.data;
        },
        async createUser(newuser) {
            var meta = {
                clientApiMethod: 'createUser',
                input: { newuser },
                successText: i18n.t("servicesystem.responses.created_object", { okey: i18n.t("servicesystem.common_objects.user.user") })
            }
            var response = await client().post(store.state.apiRouteRoot + "User/add", newuser, { meta: meta })
            return response?.data;
        },
        async changeUser(user) {
            var meta = {
                clientApiMethod: 'changeUser',
                input: { user },
                successText: i18n.t("servicesystem.responses.changed_object", { okey: i18n.t("servicesystem.common_objects.user.user") })
            }
            var response = await client().patch(store.state.apiRouteRoot + "User/" + user.Id, user, { meta: meta })
            return response?.data;
        },
        async changeUserActive(userId) {
            var meta = {
                clientApiMethod: 'changeUserActive',
                input: { userId: userId },
                successText: i18n.t("servicesystem.responses.changed_object", { okey: i18n.t("servicesystem.common_objects.user.user") })
            }
            var response = await client().patch(store.state.apiRouteRoot + "User/toggleactive/" + userId, null, { meta: meta })
            return response?.data;
        },
        async setPasswordForUser(user) {
            var meta = {
                clientApiMethod: 'setPasswordForUser',
                input: { user: user },
                successText: i18n.t("servicesystem.responses.changed_object", { okey: i18n.t("servicesystem.common_objects.commonterms.password") })
            }
            var response = await client().post(store.state.apiRouteRoot + "User/changePasswordFor/" + user.Email, user, { meta: meta })
            return response?.data;
        },
    }
}